var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgApplicationSubmitted(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 214.853,
    height: 199.772,
    viewBox: "0 0 214.853 199.772",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1045.745 -199)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1045.745 199)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 196.056,
    height: 135.731,
    rx: 2,
    transform: "translate(9.399 54.642)",
    fill: "#d8d8d8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.712-.75H179.641A34.5,34.5,0,0,1,214.1,33.712v85.6a34.5,34.5,0,0,1-34.462,34.462H33.712A34.5,34.5,0,0,1-.75,119.316v-85.6A34.5,34.5,0,0,1,33.712-.75ZM179.641,134.981a15.682,15.682,0,0,0,15.665-15.665v-85.6a15.682,15.682,0,0,0-15.665-15.665H33.712A15.682,15.682,0,0,0,18.047,33.712v85.6a15.682,15.682,0,0,0,15.665,15.665Z",
    transform: "translate(0.75 45.994)",
    fill: "#d8d8d8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.249,200.149a9.4,9.4,0,0,1-9.4-9.4V31.549a10.513,10.513,0,0,0-10.5-10.5h-39.8a10.513,10.513,0,0,0-10.5,10.5v159.2a9.4,9.4,0,0,1-18.8,0V31.549a29.332,29.332,0,0,1,29.3-29.3h39.8a29.332,29.332,0,0,1,29.3,29.3v159.2A9.4,9.4,0,0,1,96.249,200.149Z",
    transform: "translate(52.45 -2.25)",
    fill: "#d8d8d8"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 28.5,
    r: 28.5,
    transform: "translate(1067 320)",
    fill: "#89c536"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1152.425,359.194a4.421,4.421,0,0,1-3.162-1.332l-9.988-10.223a4.421,4.421,0,0,1,6.325-6.179l6.266,6.414,11.865-16.909a4.421,4.421,0,1,1,7.238,5.079l-14.925,21.269a4.421,4.421,0,0,1-3.262,1.867Q1152.6,359.194,1152.425,359.194Z",
    transform: "translate(-59.393 4.975)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplicationSubmitted);
export default __webpack_public_path__ + "static/media/application_submitted.5a7ab74e2a146d24ecb470c3e994dc67.svg";
export { ForwardRef as ReactComponent };